import { useAuth0 } from "@auth0/auth0-react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { useGetLocationParams } from "~hooks/useGetLocationParams.ts";

type Props = {
  closePopover: () => void;
};

export const UserOptions = ({ closePopover }: Props) => {
  const { formatMessage } = useIntl();
  const { logout } = useAuth0();
  const navigate = useNavigate();
  const { customerId, sport, organizationId } = useGetLocationParams();

  const onLogoutClick = () => {
    closePopover();
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  const onUserDetailsClick = () => {
    closePopover();
    navigate(`${customerId}/admin/${sport}/${organizationId}/user-details`, { state: { from: window.location.pathname } });
  };

  const isUserDetailsAvailable = customerId && sport && organizationId;

  return (
    <div>
      <div className="app-settings-content-block-title">{formatMessage({ id: "app.settings.user.options" })}</div>
      {isUserDetailsAvailable && (
        <div className={"user-option-link"} onClick={onUserDetailsClick}>
          <i className="fa-solid fa-user icon" />
          <div className="text">{formatMessage({ id: "user.details" })}</div>
        </div>
      )}
      <div className={"user-option-link"} onClick={onLogoutClick}>
        <i className="fa-solid fa-right-from-bracket icon" />
        <div className="text bold">{formatMessage({ id: "logout" })}</div>
      </div>
    </div>
  );
};
